module.exports = __webpack_public_path__ + "static/img/2.b98c67d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/2.png
// module id = AYDn
// module chunks = 0